module.exports = __webpack_public_path__ + "static/img/icon_YY@2x.01582a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_YY@2x.png
// module id = rmpm
// module chunks = 0